<template>
  <Chart :chartData="computedData" :options="computedOptions" />
</template>

<script>
  import ChartMetrics from '@/mixins/ChartMetrics'
  import merge from 'lodash/merge'
  import utils from '@/utils'

  const colors = [
    '#66cc66',
    '#6699ff',
  ]

  export default {
    name: 'ChartDisk',
    mixins: [
      ChartMetrics,
    ],
    computed: {
      computedData() {
        const datasets = [{
          backgroundColor: colors[0] + '66',
          borderColor: colors[0],
          borderWidth: 2,
          data: this.data ? this.data[0]: [],
          fill: true,
          label: 'Main Disk',
          pointRadius: 0,
          spanGaps: false,
        }, {
          borderColor: colors[0],
          borderDash: [5],
          borderWidth: 2,
          data: this.data ? this.data[1]: [],
          fill: false,
          label: 'Total',
          pointRadius: 0,
          spanGaps: false,
        }]
        if (this.data && this.data.length > 2) {
          datasets.push({
            backgroundColor: colors[1] + '66',
            borderColor: colors[1],
            borderWidth: 2,
            data: this.data ? this.data[2]: [],
            fill: true,
            label: 'EBS Disk',
            pointRadius: 0,
            spanGaps: false,
          }, {
            borderColor: colors[1],
            borderDash: [5],
            borderWidth: 2,
            data: this.data ? this.data[3]: [],
            fill: false,
            label: 'Total',
            pointRadius: 0,
            spanGaps: false,
          })
        }
        return {datasets}
      },
      computedOptions() {
        return merge(this.options, {
          scales: {
            yAxes: [{
              ticks: {
                min: 0,
                suggestedMax: this.maxValue,
                maxTicksLimit: 10,
                stepSize: 1024 * 1024 * 1024,
                callback(value) {
                  return utils.prettyBytes(value);
                },
              },
            }],
          },
          tooltips: {
            mode: 'index',
            intersect: false,
            callbacks: {
              label(tooltipItem, data) {
                if (tooltipItem.datasetIndex === 1 || tooltipItem.datasetIndex === 3) {
                  return null
                }
                const prefix = data.datasets[tooltipItem.datasetIndex].label
                const value = +data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].y
                const total = +data.datasets[tooltipItem.datasetIndex + 1].data[tooltipItem.index].y
                const prettyValue = utils.prettyBytes(value)
                const prettyTotal = utils.prettyBytes(total)
                const percent = Math.round(100 * value / total)
                return ` ${prefix}: ${prettyValue} / ${prettyTotal} (${percent}%)`
              },
              labelColor(tooltipItem, chart) {
                if (tooltipItem.datasetIndex === 0 || tooltipItem.datasetIndex === 2) {
                  return {
                    borderColor: chart.data.datasets[tooltipItem.datasetIndex].backgroundColor,
                    backgroundColor: chart.data.datasets[tooltipItem.datasetIndex].backgroundColor,
                  }
                }
              }
            }
          },
        })
      },
    },
  }
</script>
